import { EHeadingStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';

import AspectRatio from '@/components/common/AspectRatio';
import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';
import { useBreakpoint } from '@/hooks/useBreakpoint';

export type TGiftCardSection = {
  title: string;
  description: string;
  image: string;
  isLeft: boolean;
};

type TGiftCardSectionImageProps = {
  image: string;
  isLeft: boolean;
  alt: string;
};

const GiftCardSectionImage = ({ image, isLeft, alt }: TGiftCardSectionImageProps) => {
  const { isMobile } = useBreakpoint();
  return (
    <AspectRatio
      ratio={isMobile ? '3:2' : '4:1'}
      hasImageHover={false}
      isMobileRounded={true}
      className={cn('rounded-lg overflow-clip lg:rounded-3xl lg:h-full', {
        'lg:w-[calc(50%-2.5rem)]': !isLeft,
        'lg:w-[50%]': isLeft,
      })}>
      <ResponsiveImage src={image} alt={alt} />
    </AspectRatio>
  );
};

export const GiftCardSection = ({ title, description, image, isLeft }: TGiftCardSection) => {
  const { isMobile } = useBreakpoint();
  return (
    <div
      className={cn(
        'flex flex-col w-full gap-8 lg:gap-0 lg:items-center justify-between mb-8 lg:my-5',
        {
          'lg:flex-row-reverse mr-10': !isLeft && !isMobile,
          'lg:flex-row mr-10': isLeft && !isMobile,
        },
      )}>
      <GiftCardSectionImage image={image} isLeft={isLeft} alt={title} />
      <div className="flex flex-col gap-5 lg:items-start lg:gap-0 lg:w-[40%]">
        <Heading variant={EHeadingStyleVariant.H4} className="text-2xl font-bold">
          {title}
        </Heading>
        <Text>{description}</Text>
      </div>
    </div>
  );
};
